export default __webpack_public_path__ + "static/media/78t.9fe8d4cf.jpg";